<template>
    <div class="vertical grow gallery-container" style="height: 100%">
        <Modal :title="$t('UploadProgress')" :showDialog="activeModal == 'Progress'" @close="cancelUpload">
            <div class="progress-container vertical" style="min-width: 30vw;">
                <ProgressBar :loaded="bytesSent" :total="bytesToSend"/>
                <Button v-if="retries > 4">{{ $t('UploadFailed') }}</Button>
                <button class="cancel-button semi-bold" style="margin-top: 12px;" @click="cancelUpload">{{ $t('Cancel') }}</button>
            </div>
        </Modal>
        <div style="margin-top: 20px;">
            <div>
                <!-- PRODUCT -->
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('Program') }}</p></td>
                        <td style="width: 400px;" class="info-field-value">
                            <input class="datalist-input" id="product-select-input" style="width: 100%" v-model="requirementObject.program"/>
                        </td>
                    </tr>
                </div>
                <!-- PLATFORM -->
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('Platform') }}</p></td>
                        <td style="width: 400px;" class="info-field-value">
                            <input class="datalist-input" list="platforms-list" id="platforms-select-input" style="width: 100%" v-model="requirementObject.platform"/>
                            <datalist id="platforms-list">
                                <option v-for="p in supportedPlatforms" :key="p" :value="p">{{ p }}</option>
                            </datalist>
                        </td>
                    </tr>
                </div>
                <!-- ARCHITECTURE -->
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('Architecture') }}</p></td>
                        <td style="width: 400px;" class="info-field-value">
                            <input class="datalist-input" list="architectures-list" id="architectures-select-input" style="width: 100%" v-model="requirementObject.architecture"/>
                            <datalist id="architectures-list">
                                <option v-for="p in supportedArchitectures" :key="p" :value="p">{{ p }}</option>
                            </datalist>
                        </td>
                    </tr>
                </div>
                <!-- VERSION -->
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('MaxVersion') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <div class="horizontal" style="width: 100%;">
                                <input class="version-input" v-model="version.major" type="number" placeholder="Major"/>
                                <input class="version-input" v-model="version.minor" type="number" placeholder="Minor"/>
                                <input class="version-input" v-model="version.patch" type="number" placeholder="Patch"/>
                            </div>
                        </td>
                    </tr>
                </div>
                <!-- FILE -->
                <div class="info-field horizontal">
                    <tr class="info-field-row">
                        <td class="title-td" style="width:200px;"><p class="info-field-title">{{ $t('VersionFile') }}</p></td>
                        <td style="width:400px;" class="info-field-value">
                            <FilePicker :title="''" :filters="['.tar.gz', '.zip', '.hex', '.bin', '.exe', '.msi']" :isDirectory="false" :isMultiple="false" @changed="changeFile"/>
                        </td>
                    </tr>
                </div>
                <div style="justify-content: center; margin-bottom: 10px;" class="horizontal">
                    <div class="error" v-if="error != ''">{{ error }}</div>
                </div>
            </div>
        </div>
        <div style="align-self: center; margin-bottom: 20px;">
            <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
        </div>
    </div>
</template>

<script>
import { addRequirement, getSoftwarePlatforms, getArchitectures, uploadRequirementFile } from '@api';
import axios from 'axios';
import Button from '../Button.vue';
import Modal from '../Modal.vue';
import FilePicker from '../FilePicker.vue'
import ProgressBar from '../ProgressBar.vue';
import { parseProgress } from '../../util/progress';

import Vue from 'vue';
var context = null;

export default {
    components: {
        Button,
        Modal,
        FilePicker,
        ProgressBar
    },
    data() {
        return {
            version: {
                major: null,
                minor: null,
                patch: null
            },
            error: '',
            requirementObject: {
                program: '',
                platform: '',
                maxVersion: '',
                architecture: ''
            },
            selectedFile: null,
            supportedPlatforms: [],
            supportedArchitectures: [],
            bytesToSend: 0,
            bytesSent: 0,
            activeModal: null,
            retries: 0,
            uploadController: null
        }
    },
    methods: {
        async getData() {
            this.supportedPlatforms = await getSoftwarePlatforms();
            this.supportedArchitectures = await getArchitectures();
        },
        async changeFile(file) {
            this.selectedFile = file;
        },
        async save() {
            if (this.selectedFile == null) {
                this.error = "Provide software file."
                return;
            }

            this.requirementObject.softwareVersion = `${this.version.major}.${this.version.minor}.${this.version.patch}`;
            this.requirementObject.fileType = this.selectedFile.type;
            this.requirementObject.fileName = this.selectedFile.name;
            this.requirementObject.fileSize = this.selectedFile.size;

            // If higher than 2GB 
            if (this.selectedFile.size > 2147483648) {
                this.error = `File can't be bigger than 2GB.`;
                return;
            }

            if (this.version.major != '' && this.version.major != null) {
                this.requirementObject.maxVersion = `${this.version.major}.${this.version.minor}.${this.version.patch}`;
            } else {
                this.requirementObject.maxVersion = '';
            }

            var id = '';
            try {
                id = await addRequirement(this.requirementObject);

                var fileForm = new FormData();
                fileForm.append('', this.selectedFile)

                this.uploadController = new AbortController();
                this.bytesSent = 0;
                this.bytesToSend = 0;
                var config = {
                    signal: this.uploadController.signal,
                    onUploadProgress: progressEvent => {
                        const { loaded, total } = parseProgress(progressEvent, context.selectedFile ? context.selectedFile.size : 0);
                        context.bytesSent = loaded;
                        context.bytesToSend = total;
                    }
                }

                this.activeModal = 'Progress';

                uploadRequirementFile(fileForm, id, config)
                    .then(response => {
                        console.dir(response);
                        this.activeModal = null;
                        this.uploadController = null;
                        this.$emit('saved');
                    }).catch(err => {
                        this.activeModal = null;
                        this.uploadController = null;
                        if (!axios.isCancel(err)) {
                            console.dir(err)
                            this.error = err;
                        }
                    })

            } catch (e) {
                console.dir(e)
                this.error = e;
                return;
            }
        },
        cancelUpload() {
            if (this.uploadController) {
                this.uploadController.abort();
            }
            this.activeModal = null;
        },
    },
    async mounted () {
        context = this;
        await this.getData();
    },
}
</script>

<style>
.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.section-title {
    font-weight: bold;
    text-align: center;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
    justify-content: center;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    align-self: center;
    width: 80%;
    margin: 0;
    padding-bottom: 5px;
}

.section-title {
    font-weight: bold;
}

select, input.datalist-input, input.version-input {
    width: 210px;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}

.version-input {
    height: 25px;
    margin: 0 10px;
    width: 100px !important;
}

.info-field-row > td {
    vertical-align: middle;
}

.error {
    font-size: 14px;
}
</style>

<style scoped>
.info-field-value {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Software/AddRequirement.vue